import { FC, memo, ReactNode } from 'react';
import '@reach/dialog/styles.css';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { useTranslation as t } from '@utils/hooks';
import { IconX } from '@nzxt/react-icons';
import extraStyles from './Modal.module.css';
import * as styles from './styles';

type Props = {
  className?: string;
  children?: ReactNode;
  open?: boolean;
  onClose: () => void;
  ariaLabel: () => string;
  disableClose?: boolean;
};

const Modal: FC<Props> = ({
  children,
  open,
  onClose,
  ariaLabel,
  disableClose = false,
}) => {
  const CLOSE_MODAL_LABEL = t('close_modal_label');

  return (
    <DialogOverlay
      isOpen={open}
      className={extraStyles.dialogOverlay}
      onDismiss={onClose}
    >
      {open ? (
        <DialogContent
          className={extraStyles.dialogContent}
          aria-label={ariaLabel()}
        >
          <div className={styles.closeButtonWrapper}>
            {!disableClose && (
              <button
                onClick={onClose}
                aria-label={CLOSE_MODAL_LABEL}
                type="button"
              >
                <IconX className={styles.closeButton} />
              </button>
            )}
          </div>
          {children}
        </DialogContent>
      ) : null}
    </DialogOverlay>
  );
};

export default memo(Modal);
